import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-warn-snackbar',
  templateUrl: './warn-snackbar.component.html',
  styleUrls: ['./warn-snackbar.component.scss'],
  standalone: false,
})
export class WarnSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackbarRef: MatSnackBarRef<WarnSnackbarComponent>,
  ) {}

  dismiss() {
    this.snackbarRef.dismiss();
  }
}
